import "./_503.js";
import "./_b4ugo.js";
import "./_carousel.js";
import "./_copybutton.js";
import "./_cta_footer.js";
import "./_editable_hero_text.js";
import "./_fade_in.js";
import "./_form_submit";
import "./_gallery_slider.js";
import "./_header.js";
import "./_home.js";
import "./_input_mask.js";
import "./_job.js";
import "./_job_application.js";
import "./_jobs.js";
import "./_maxlength.js";
import "./_modal.js";
import "./_no_paste.js";
import "./_partner_form_choice.js";
import "./_plans_preview.js";
import "./_project.js";
import "./_qualifying_question.js";
import "./_reasons_to_trust.js";
import "./_review_slider.js";
import "./_scroll_notice.js";
import "./_scroll_to_error.js";
import "./_social_review_links.js";
import "./_timeline.js";
import "./_video_set.js";

// Initialize galleries, only on pages where it exists

const baguetteBox = require("baguettebox.js");

if (document.getElementsByClassName("gallery")) {
  baguetteBox.run(".gallery", {
    buttons: "true",
  });
}

// Show all the galleries when the show all projects button is clicked
if (document.getElementById("loadMoreProjects")) {
  let loadMoreProjects = document.getElementById("loadMoreProjects");
  loadMoreProjects.onclick = function(event) {
    let galleries = document.getElementById("galleries");
    galleries.style.height = "auto";
    let loadMoreBlock = document.getElementById("loadMoreBlock");
    loadMoreBlock.style.display = "none";
  };
}

// Lazy-load everything for a snappier experience
var vidDefer = document.getElementsByTagName("iframe");
for (var i = 0; i < vidDefer.length; i++) {
  if (vidDefer[i].getAttribute("data-src")) {
    vidDefer[i].setAttribute("src", vidDefer[i].getAttribute("data-src"));
  }
}

var imgDefer = document.getElementsByTagName("img");
for (var i = 0; i < imgDefer.length; i++) {
  if (imgDefer[i].getAttribute("data-src")) {
    imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("data-src"));
  }
}

for (var i = 0; i < imgDefer.length; i++) {
  if (imgDefer[i].getAttribute("data-srcset")) {
    imgDefer[i].setAttribute(
      "srcset",
      imgDefer[i].getAttribute("data-srcset")
    );
  }
}

var bgImgDefer = document.getElementsByClassName("bgImgDefer");
for (var i = 0; i < bgImgDefer.length; i++) {
  if (bgImgDefer[i].getAttribute("data-style")) {
    bgImgDefer[i].setAttribute(
      "style",
      bgImgDefer[i].getAttribute("data-style")
    );
  }
}
